(function () {
  var root = document.querySelector('[data-sph-product]');
  if (!root) return;

  var price = root.querySelector('[data-sph-price]');
  var stock = root.querySelector('[data-sph-stockbox]');
  var alerts = Array.prototype.slice.call(root.querySelectorAll('.sph-alert'));
  var info = alerts.filter(function (a) { return a !== stock; })[0];

  if (price && stock) {
    var row = document.createElement('div');
    row.className = 'sph-statusrow';
    price.insertAdjacentElement('afterend', row);
    row.appendChild(stock);

    if (info) {
      var label = 'Versandinfo';
      var text =
        '<span style="display:block;margin-bottom:4px">\u2022 Liefertermin innerhalb 24 h per E-Mail</span>' +
        '<span style="display:block">\u2022 Am Liefertag ruft der Fahrer eine Stunde vorher an</span>';

      var wrap = document.createElement('span');
      wrap.className = 'sph-info';
      wrap.innerHTML =
        '<button type="button" class="sph-info__b" aria-expanded="false" aria-label="' + label + '">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>' +
          '<span>' + label + '</span>' +
        '</button>' +
        '<span class="sph-info__pop" hidden>' + text + '</span>';
      row.appendChild(wrap);
      info.remove();

      var btn = wrap.querySelector('.sph-info__b');
      var pop = wrap.querySelector('.sph-info__pop');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !pop.hidden;
        pop.hidden = open;
        btn.setAttribute('aria-expanded', String(!open));
      });
      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) { pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
      });
    }
  }

  var facts = root.querySelector('.sph-keyfacts');
  if (!facts) return;

  var specs = {};
  root.querySelectorAll('.sph-sheet__c').forEach(function (c) {
    var k = c.querySelector('dt'), v = c.querySelector('dd');
    if (k && v) specs[k.textContent.trim().toLowerCase()] = v.textContent.trim();
  });

  var wanted = [
    ['Struktur', ['struktur', 'profil']],
    ['Plattenst\u00e4rke', ['plattenst\u00e4rke', 'st\u00e4rke', 'dicke']],
    ['Lichtdurchl\u00e4ssigkeit', ['lichtdurchl\u00e4ssigkeit']],
    ['Garantie', ['garantie']]
  ];

  var html = '';
  wanted.forEach(function (w) {
    var v = null;
    for (var i = 0; i < w[1].length && v === null; i++) {
      for (var key in specs) { if (key.indexOf(w[1][i]) === 0) { v = specs[key]; break; } }
    }
    if (v) html += '<div><span>' + w[0] + '</span><b>' + v + '</b></div>';
  });

  if (html) facts.innerHTML = html;
})();
